import axios from 'axios'
import { isDefined } from './utils'
import { $getToken, $logout } from '@/helpers'
import { isIOS } from '@/constants'

import { useToastStore } from '@/stores'
import router from '@/router'

const apiDomain = import.meta.env.VITE_API_DOMAIN
export const api = axios.create({
  baseURL: apiDomain + import.meta.env.VITE_API_BASE,
  responseType: 'json',
})

api.interceptors.request.use((options) => {
  const token = $getToken()

  if (token)
    options.headers.Authorization = token

  options.params = {
    ...options.params,
    // max_sid: queryStore.$state.max_sid || '0',
    // max_pid: queryStore.$state.max_pid || '0',
    // max_app_id: queryStore.$state.max_app_id || '0',
    max_platform: isIOS ? 2 : 1, // 1: Android, 2: iOS, 3: Windows
    max_os: isIOS ? 2 : 1, // 1: Android, 2: iOS, 3: Windows
    max_version: __APP_VERSION__,
  }

  return options
})

api.interceptors.response.use((response) => {
  // 用户 TOKEN 过期
  if (response.data.code === 401) {
    useToastStore().$toast('用户信息过期，请重新登录')
    $logout()
    const redirect = window.encodeURIComponent(router.currentRoute.fullPath)
    router.replace({
      name: 'home',
      query: {
        redirect,
      },
    })
    return
  }

  if (isDefined(response.data.code) && response.data.code !== 0)
    return Promise.reject(response.data)
  if (isDefined(response.data.result) && response.data.result !== 1)
    return Promise.reject(response.data)

  return response.data
})
